﻿export class Utilities {

    public static splitCamelCase(text: string, join: string = " ") {

        return text
            .replace(/(([A-Z]+)|([A-Z][a-z]))/g, " $1")
            .trim()
            .split(" ")
            .map(v => {
                v = v.trim();
                if (v != v.toUpperCase())
                    v = v.toLowerCase();
                return v;
            })
            .join(join).replace(/^\w/g, x => x.toUpperCase());
    }

    public static compareArrays<T>(arr1: T[] | undefined, arr2: T[] | undefined) {

        if (arr1 === undefined || arr2 === undefined)
            return arr1 === arr2;

        const len1 = arr1.length;
        if (len1 !== arr2.length)
            return false;
        else
            return arr1.every((v, i) => arr1[i] === arr2[i]);
    }

    public static capitalizeFirstLetter(string: string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    public static addSpacesBeforeCapitals(string: string) {
        return string.replace(/([A-Z][a-z])/g, " $1").trim();
    }

    public static enumerateStringArrayWithMaximum(strings: string[], max: number= Number.POSITIVE_INFINITY) {
        let line = '';

        for (let i = 0; i < strings.length; i++) {
            var name = strings[i];
            if (i === max - 1) {
                line += name + ' and ' + (strings.length - max) + ' more.';
                return line;
            }
            else if (i < strings.length - 2) {
                line += name + ', ';
            }
            else if (i === strings.length - 2) {
                line += name + ' and ';
            }
            else
                line += name + '.';
        };

        return line;
    }
}